// extracted by mini-css-extract-plugin
module.exports = {"container":"_3twRl","noSpacing":"_2TH9h","noSpacingTop":"v-SM1"};